import { CheckboxField, ICheckboxFieldProps } from '@cian/components';

import * as React from 'react';

interface IIsByCommercialOwnerProps extends Pick<ICheckboxFieldProps, 'value' | 'onValueChange'> {
  className?: string;
}

export const IsByCommercialOwner: React.FC<IIsByCommercialOwnerProps> = ({ value, onValueChange }) => {
  return <CheckboxField label="От собственника" value={value} onValueChange={onValueChange} />;
};

IsByCommercialOwner.displayName = 'IsByCommercialOwner';
